import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} [className]
 */
/**
 * @param {Props} props
 */
const MotifVerticalNavigationContent = ({ className = '', children }) => {
  const classes = classNames({
    'motif-vertical-navigation-content': true,
    'motif-vertical-navigation-scrolls': true,
    [className]: true
  });

  return <div className={classes} data-motif-vertical-navigation-content>{children}</div>;
};

MotifVerticalNavigationContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
    .isRequired
};

export { MotifVerticalNavigationContent };
